/*
  rk Große Zahlen: [data-rk-count] zählt beim ersten Sichtbarwerden von 0 hoch.
  Ohne JS, bei reduzierter Bewegung und im Theme-Editor steht sofort der Endwert.
*/
(() => {
  if (window.RkStats) return;
  window.RkStats = true;

  const DURATION = 1400;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const parse = (raw) => {
    const match = raw.trim().match(/^(\d+(?:[.,]\d+)?)$/);
    if (!match) return null;
    const decimals = (match[1].split(/[.,]/)[1] || '').length;
    return { value: parseFloat(match[1].replace(',', '.')), decimals, comma: match[1].includes(',') };
  };

  const format = (value, target) => {
    const text = value.toFixed(target.decimals);
    return target.comma ? text.replace('.', ',') : text;
  };

  const run = (element) => {
    const target = parse(element.dataset.rkCount || '');
    if (!target || target.value === 0) return;
    const start = performance.now();
    const step = (now) => {
      const t = Math.min((now - start) / DURATION, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      element.textContent = format(target.value * eased, target);
      if (t < 1) requestAnimationFrame(step);
      else element.textContent = element.dataset.rkCount;
    };
    element.textContent = format(0, target);
    requestAnimationFrame(step);
  };

  const init = () => {
    if (reducedMotion.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          entry.target.querySelectorAll('[data-rk-count]').forEach(run);
        });
      },
      { threshold: 0.2 }
    );
    document.querySelectorAll('.rk-stats:not([data-rk-count-bound])').forEach((section) => {
      section.dataset.rkCountBound = 'true';
      section.querySelectorAll('[data-rk-count]').forEach((element) => {
        const target = parse(element.dataset.rkCount || '');
        if (target && target.value !== 0) element.textContent = format(0, target);
      });
      observer.observe(section);
    });
  };

  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
